import React from 'react';
import { formatCurrency, formatDate, differenceDate } from '@ajaibid/utils';
import { Badge } from '@ajaibid/components';

import StockCodeLink from 'Component/StockCodeLink';

import OrderToggleButton from '../../components/OrderToggleButton';
import ActionButtons from '../../components/ActionButtons';

function getOrderCondition(comparator) {
  switch (comparator) {
    case 'LTE':
      return '≤';
    case 'GTE':
      return '≥';
    default:
      return comparator;
  }
}

function getOrderStatus(status) {
  switch (status) {
    case 'OPEN':
      return 'Sedang berjalan';
    case 'EXPIRED':
      return 'Berakhir';
    case 'PAUSED':
      return 'Dijeda';
    case 'MATCHED':
      return 'Triggered';
    default:
      return status;
  }
}

function isActive(status) {
  return status === 'OPEN';
}

/**
 * @typedef {import('@services/api/stock/order/auto/order').AutoOrder}  AutoOrder
 * @typedef {import('@ajaibid/components').TableColumnDefinition<AutoOrder>[]}  TableColumnDefinition
 */

function useColumns() {
  /**
   * @type {TableColumnDefinition}
   */
  const columns = [
    {
      name: 'Periode',
      renderCell: (ctx) =>
        `${formatDate(ctx.row.original.start_date, 'DD MMM YYYY')} - ${formatDate(
          ctx.row.original.end_date,
          'DD MMM YYYY'
        )}`,
      size: 140,
    },
    {
      name: 'Durasi',
      renderCell: (ctx) =>
        `${differenceDate(ctx.row.original.start_date, ctx.row.original.end_date)} hari`,
      size: 80,
    },
    {
      path: 'side',
      name: 'Aksi',
      renderCell: (ctx) => <Badge type="Order" orderVariant={ctx.getValue()} />,
      size: 80,
    },
    {
      path: 'code',
      name: 'Aset',
      renderCell: (ctx) => <StockCodeLink code={ctx.getValue()} />,
      size: 80,
    },
    {
      path: 'lot',
      name: 'Lot',
      size: 60,
      renderCell: (ctx) => ctx.getValue(),
    },
    {
      path: 'comparator',
      name: 'Syarat',
      size: 100,
      renderCell: (ctx) =>
        `Harga ${getOrderCondition(ctx.getValue())} ${formatCurrency(
          ctx.row.original.value,
          'IDR'
        )}`,
    },
    {
      path: 'order_price',
      name: 'Harga',
      size: 100,
      renderCell: (ctx) => formatCurrency(ctx.getValue(), 'IDR'),
    },
    {
      path: 'order_status',
      name: 'Status',
      size: 100,
      renderCell: (ctx) => getOrderStatus(ctx.getValue()),
    },
    {
      name: '',
      action: true,
      renderCell: (ctx) => <OrderToggleButton autoOrder={ctx.row.original} />,
    },
    {
      name: '',
      action: true,
      renderCell: (ctx) => <ActionButtons autoOrder={ctx.row.original} />,
    },
  ];
  return columns;
}
export default useColumns;
